import { observer } from "mobx-react-lite";
import React, { useContext, useEffect, useState } from "react";
import { RootStoreContext } from "../../app/stores/rootStore";

// reactstrap components
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Row, Col, Nav, NavItem, NavLink, TabContent, TabPane, Card } from "reactstrap";
import classnames from "classnames";
import classNames from "classnames";
import { useTranslation } from "react-i18next";
import { translationHookOptions } from "../../app/localization/localization";
import { ICompanyDisclaimerRegistrationDetail, ILanguage } from "../../app/models/company";
import { Field } from "react-final-form";
import { toast } from "react-toastify";

interface IProps {
  title: string;
  isOpen: boolean;
  size?: string;
  toggle: () => void;
  action: () => void;
  message: string;
  disclaimerLanguages: ICompanyDisclaimerRegistrationDetail[]
  allLanguages: ILanguage[]
}

const RegistrationConfirmModal: React.FC<IProps> = ({
  isOpen,
  toggle,
  action,
  title,
  size,
  message,
  disclaimerLanguages,
  allLanguages
}) => {
  const rootStore = useContext(RootStoreContext);
  const { theme } = rootStore.commonStore;
  const [t] = useTranslation(["translation","registration"], translationHookOptions);

  const[IsAcceptCondition , setIsAcceptCondition]= useState(false)
  const handleConfirm = () => {
    action();
    toggle();
  };
  const handleOnChange = (e: any) => {
    var IsChecked = e.target.checked;
    setIsAcceptCondition(IsChecked);
  };
  const handleCancel = () => {
    toggle();
  };
  const toggleTab = (tab: string) => {
    if (activeTab !== tab) setActiveTab(tab);
  };
  const localStorageLangKey = "lang_p";
  useEffect(() => {
    setIsAcceptCondition(false);
    if(isOpen){
    const lsLang = window.localStorage.getItem(localStorageLangKey);
    if( lsLang && lsLang=="it-IT" &&  disclaimerLanguages.findIndex(x=> x.languageId==1)>-1) {
      setActiveTab("1")}
    if(lsLang && lsLang=="en-US" &&  disclaimerLanguages.findIndex(x=> x.languageId==2)>-1){setActiveTab("2")}
    }
    return () => {};
  }, [isOpen]);

  const [activeTab, setActiveTab] = useState("1");

  return (
    <Modal
      className=""
      isOpen={isOpen}
      toggle={toggle}
      size={size ? size : "lg"}
    >
      {title && (
        <ModalHeader
          style={{ height: "10px" }}
          close={
            <button
              className="closeModalIcon"
           
              onClick={() => {
                toggle();
              }}
            >
              <i className="far fa-times-circle fa-lg" style={{color:"grey"}}></i>
            </button>
          }
          toggle={toggle}
        >
          {title}
        </ModalHeader>
      )}
      <ModalBody>
      <Row>
                  <Col sm={12} lg={12}>
                    <Nav tabs className={"navDisclaimer"}>
                      {disclaimerLanguages &&
                       disclaimerLanguages.map((l) => (
                          <NavItem key={l.languageId}>
                            <NavLink
                              href="#"
                              className={classnames({
                                active: activeTab === l.languageId.toString(),
                              })}
                              onClick={() => {
                                toggleTab(l.languageId.toString());
                              }}
                            >
                              <span
                                className={classnames(
                                  "mr-1 flag-icon",
                                  allLanguages.filter((x) => x.id === l.languageId)[0]
                                    .flagIcon
                                )}
                              ></span>
                              {/* {allLanguages.filter((x) => x.id === l.languageId)[0].name} */}
                            </NavLink>
                          </NavItem>
                        ))}
                    </Nav>
                    <TabContent activeTab={activeTab} className="pt-0 tabDisclaimer">
                     
                      {disclaimerLanguages &&
                        disclaimerLanguages.map((l, index) => (
                          <TabPane key={l.languageId} tabId={l.languageId.toString()}>
                            <Row>
                              <Col>
                                <Card body className="DisclaimerCard ">
                                  
                                  <textarea   
                                  className="form-control form-control-alternative"
                                  style={{width:"100%" ,  backgroundColor:"white"}} rows={10} readOnly={true}>
                                  {l.description}
                                  </textarea>
                                  
                              
                                </Card>
                              </Col>
                            </Row>
                          </TabPane>
                        ))}
                    </TabContent>
                  </Col>
                </Row>

     <Row>
      <Col  style={{marginLeft:"1.4em" , marginTop:"1em"}}>
     <input
     defaultChecked={IsAcceptCondition}
                type="checkbox"
                name="Condiction"
                className="custom-control-input"
                id={"Condiction"}
                onChange={(e: any) => handleOnChange(e)}
              />
              <label className="custom-control-label" htmlFor={"Condiction"} style={{fontSize:16}}>
              {t("label_condition", {ns: "registration" })}
              </label>
              </Col>
     </Row>
      </ModalBody>
     
      <ModalFooter>
    
        <Button
          color="dark"
          onClick={handleConfirm}
          disabled={!IsAcceptCondition}
        >
        {t("button_condition", {ns: "registration" })}
        </Button>
        <Button
          color="dark"
          onClick={handleCancel}
        >
          {t("cancel")}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default observer(RegistrationConfirmModal);
